import React, { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPageNavActive, setIsPageNavActive] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // When scroll position > 0 (starts scrolling)
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handlePageNavToggle = (event) => {
      setIsPageNavActive(Boolean(event.detail?.active));
    };
    window.addEventListener("pagenav:toggle", handlePageNavToggle);
    return () =>
      window.removeEventListener("pagenav:toggle", handlePageNavToggle);
  }, []);

  const isHome = location.pathname === "/";
  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-[300]">
        <div
          className={`transition-all duration-300 ${
            isPageNavActive
              ? "opacity-0 pointer-events-none translate-y-[-8px]"
              : "opacity-100"
          }`}
        >
          <Navbar isScrolled={isScrolled} />
        </div>
        {isHome && (
          <div
            className={`transition-all duration-500 overflow-hidden ${
              isScrolled
                ? "max-h-0 opacity-0 translate-y-[-100%]"
                : "max-h-40 opacity-100 translate-y-0"
            }`}
          >
            <TopBar />
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
